import React, { useEffect, useState } from "react";
import Input from "../../../components/input";
import FIlterSelect from "../../../components/filter-select";
import Table from "../../../components/table";
import Button from "../../../components/button";


interface PaymentData {
    _id:string;
}

interface PaymentsProps {
    data: PaymentData[];
}

const Payments: React.FC<PaymentsProps> = ({
    data
}) => {

    console.log(data, "payment")

        const [filteredData, setFilteredData] = useState<PaymentData[]>([]);
        const [searchQuery, setSearchQuery] = useState("");
        const [selectedType, setSelectedType] = useState("");

        const columns = [
        {header: "Order ID", accessor: "orderId"},
        {header: "Source", accessor: "source"},
        {header: "Amount", accessor: "totalAmount"},
        {header: "Order Date", accessor: "createdAt"},
        {header: "Status", accessor: "status"},
        {header: "Payment", accessor: "payment"},
        {header: "Action", accessor: "_id"},
    ];
     const combinedData = data
    
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };
     
    const handleOrderFilterChange = (selectedValue: string) => {
        setSelectedType(selectedValue);
    };


    return ( 
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Payment</p>


                <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search by name or email"
                        icon="searchIcon"
                    />

                    {/* <FIlterSelect
                        name="status"
                        options={[
                            { value: "b2b", label: "Business" },
                            { value: "b2c", label: "Customer" },
                        ]}
                        className="mt-2 md:-mt-2 w-full md:w-[50%]"
                        icon="filterIcon"
                        onChange={handleOrderFilterChange}
                        value={selectedType}
                    /> */}
                </div>

            </div>


            {/* {combinedData?.length > 0 ? (
                <Table
                    columns={columns}
                    data={combinedData}
                    selectedUserId={null}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold flex flex-col items-center gap-5 mx-auto">
                    No Payment yet
                </div>
            )} */}

        </div>
     );
}
 
export default Payments;